/// The head of a due date in the installments list: the date, how many
/// installments fall due on it, their issues still to review and the ones
/// already reviewed ( from the sessions loaded so far ), and their total.
/// Counts and total are of the installments shown ( the filters apply );
/// the total leaves out the void and compensated ones.
class PaymentInstallmentDueHeader extends MUIView
{
    private dueDateLabel:MUILabel = null;
    private countLabel:MUILabel = null;
    private issuesLabel:MUILabel = null;
    private reviewedLabel:MUILabel = null;
    private totalLabel:MUILabel = null;

    awakeFromHTML(){
        this.dueDateLabel = MUIOutlet( this, "due-date-lbl", "MUILabel" );
        this.countLabel = MUIOutlet( this, "count-lbl", "MUILabel" );
        this.issuesLabel = MUIOutlet( this, "issues-lbl", "MUILabel" );
        this.reviewedLabel = MUIOutlet( this, "reviewed-lbl", "MUILabel" );
        this.totalLabel = MUIOutlet( this, "total-lbl", "MUILabel" );
    }

    /// Sorting by date: the card shows the session day instead of the due
    showsDate = false;

    setInstallments( installments:PaymentInstallment[], issues:PaymentSessionIssues[] ) {
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;

        let due_date = this.showsDate ? installments[0]?.date : installments[0]?.dueDate;
        this.dueDateLabel.text = due_date != null ? ad.dateFormatter.stringFromDate( due_date ) : "";

        this.countLabel.text = PaymentInstallmentDueHeader.countString( installments.length, "ONE_PAYMENT", "1 PAYMENT", "N_PAYMENTS", "%d PAYMENTS" );

        let pending = 0;
        let reviewed = 0;
        for (let summary of issues) {
            if (summary == null) continue;
            pending += summary.pending;
            reviewed += summary.reviewed;
        }

        this.issuesLabel.text = PaymentInstallmentDueHeader.countString( pending, "ONE_PENDING_ISSUE", "1 PENDING ISSUE", "N_PENDING_ISSUES", "%d PENDING ISSUES" );
        this.issuesLabel.hidden = pending == 0;

        this.reviewedLabel.text = PaymentInstallmentDueHeader.countString( reviewed, "ONE_REVIEWED_ISSUE", "1 REVIEWED", "N_REVIEWED_ISSUES", "%d REVIEWED" );
        this.reviewedLabel.hidden = reviewed == 0;

        let total = 0;
        for (let installment of installments) {
            if (installment.status == PaymentInstallmentStatus.void || installment.status == PaymentInstallmentStatus.compensated) continue;
            total += installment.amount ?? 0;
        }
        this.totalLabel.text = ad.currencyFormatter.stringFromNumber( Math.round( total * 100 ) / 100 );
    }

    static countString( count:number, oneKey:string, oneFallback:string, manyKey:string, manyFallback:string ) : string {
        if (count == 1) return MIOLocalizeString( oneKey, oneFallback );
        return MIOLocalizeString( manyKey, manyFallback ).replace( "%d", count.toString() );
    }
}
